/* React */
import React, { useLayoutEffect, useState } from "react";
/* Thorium-UI */
import { ThoriumRoot, useMobileStatus } from "thorium-ui";
/* Custom Components */
import TopNav from "./components/common/TopNav";
/* Customization */
import ct from "./customThemes";
import "./fonts/iconmonstr-iconic-font.css";
/* Stylesheets */
import "./sass/main.sass";
import Views from "./views";

export const App = () => {
   const isMobile = useMobileStatus();
   const [homeVisible, setHomeVisible] = useState(false);
   const [aboutVisible, setAboutVisible] = useState(false);
   const [projectsVisible, setProjectsVisible] = useState(false);
   const [contactVisible, setContactVisible] = useState(false);
   const [currentSection, setCurrentSection] = useState("home");

   let homeView, aboutView, projectsView, contactView;

   // Track visible state of sections when the page is scrolled
   useLayoutEffect(() => {
      const observations = [homeView, aboutView, projectsView, contactView];
      const observer = new IntersectionObserver(
         (entries) => {
            entries.forEach((entry) => {
               const target = entry.target.id;
               if (entry.isIntersecting) {
                  switch (target) {
                     case "home-view":
                        setHomeVisible(true);
                        setCurrentSection("home");
                        break;
                     case "about-view":
                        setAboutVisible(true);
                        setCurrentSection("about");
                        break;
                     case "projects-view":
                        setProjectsVisible(true);
                        setCurrentSection("projects");
                        break;
                     case "contact-view":
                        setContactVisible(true);
                        setCurrentSection("contact");
                        break;
                     default:
                        break;
                  }
               } else {
                  switch (target) {
                     case "home-view":
                        setHomeVisible(false);
                        break;
                     case "about-view":
                        setAboutVisible(false);
                        break;
                     case "projects-view":
                        setProjectsVisible(false);
                        break;
                     case "contact-view":
                        setContactVisible(false);
                        break;
                     default:
                        break;
                  }
               }
            });
         },
         { threshold: window.innerHeight / 4000, rootMargin: "0px" }
      );
      observations.forEach((observation) => {
         observation && observer.observe(observation);
      });

      return () => {
         observations.forEach((observation) => observer.unobserve(observation));
      };
   }, [homeView, aboutView, projectsView, contactView, isMobile]);

   return (
      <div className="wrapper" id="home">
         <ThoriumRoot customThemes={ct} enableMotion overrideSysTheme>
            <TopNav currentSection={currentSection} />
            <Views.Home visible={homeVisible} ref={(el) => (homeView = el)} />
            <div id="about" />
            <Views.About
               visible={aboutVisible}
               ref={(el) => (aboutView = el)}
            />
            <div id="projects" />
            <Views.Projects
               visible={projectsVisible}
               ref={(el) => (projectsView = el)}
            />
            <div id="contact" />
            <Views.Contact
               visible={contactVisible}
               ref={(el) => (contactView = el)}
            />
         </ThoriumRoot>
      </div>
   );
};

export default App;
